import { useTranslation } from '@repo/translations/use-translation';

import { useScrollToLocationHash } from '../../../../hooks/useScrollTo';
import { ProgramPlanContent } from '../ProgramPlanContent/ProgramPlanContent';

import styles from './ProgramPlan.module.css';

import type { MembershipsComparison } from '@repo/types/memberships-comparison';

export interface ProgramPlanProps {
  membershipsComparison: MembershipsComparison;
  isBasicCustomer: boolean;
}

export const PROGRAM_PLANS_ANCHOR_ID = 'program-plans-comparison';

export const ProgramPlan = ({ membershipsComparison, isBasicCustomer }: ProgramPlanProps) => {
  const { t } = useTranslation();
  useScrollToLocationHash(PROGRAM_PLANS_ANCHOR_ID);

  return (
    <div
      className={styles.programContainer}
      data-testid="program-plans-comparison"
      id={PROGRAM_PLANS_ANCHOR_ID}>
      <h2 data-testid="plans-title" className={styles.title}>
        {t('loyalty-program.public-landing-page.program-plans.title')}
      </h2>
      <div className={styles.programPlans}>
        <ProgramPlanContent
          plan="BASIC"
          membershipsComparison={membershipsComparison}
          isBasicCustomer={isBasicCustomer}
        />
        <ProgramPlanContent
          plan="PREMIUM"
          membershipsComparison={membershipsComparison}
          isBasicCustomer={isBasicCustomer}
        />
      </div>
    </div>
  );
};
